let k_grid;
let $exportSelect;
let k_exportSelect;

const EXCEL = 1;
const CSV = 2;

export default function ($targetElement, k_gridToExport) {
    $exportSelect = $targetElement;
    k_grid = k_gridToExport;

    if (!k_grid) return;
    
    createExportSelect();
    attachSelectChangeEvent();
}
const createExportSelect = () => {
    k_exportSelect = $exportSelect.kendoDropDownList({
        optionLabel: 'Export As...', dataTextField: 'text', dataValueField: 'value', dataSource: [
            {text: 'Excel', value: EXCEL}, {text: 'CSV', value: CSV}
        ]
    }).data('kendoDropDownList');
}

const attachSelectChangeEvent = () => {
    $exportSelect.bind('change', function () {
        let value = this.value;
        k_exportSelect.select(0);
        if (value === EXCEL) {
            exportToExcel();
        } else if (value === CSV) {
            exportToCSV();
        }
    });
}

let exportToExcel = () => {
    k_grid.saveAsExcel();
}
const exportToCSV = () => {
    let csv = generateCsv();

    const fileName = k_grid.options.excel.fileName.replace('.xlsx', '.csv');
    if (navigator.msSaveBlob) {
        downloadCsvForIE(csv, fileName);
        return;
    }

    downloadCsv(csv, fileName);
};

const generateCsv = () => {
    let csv = addColumnsToCsv();
    return (csv + addDataToCsv());
}
const addColumnsToCsv = () => {
    let csv = ''
    const columns = k_grid.columns
    $.each(columns, function (index, item) {
        let field = item.title || item.field;
        if (field) {
            csv += field + ',';
        }
    });

    return csv + '\n';
}
const addDataToCsv = () => {
    let csv = '';
    const data = k_grid.dataSource.view();
    const columns = k_grid.columns;
    $.each(data, function (index, item) {
        columns.forEach(function (ele) {
            let field = ele.field;
            if (field) {
                csv += (item[ele.field] || '') + ',';
            }
        });
        csv += '\n';
    });

    return csv;
}

const downloadCsvForIE = (csv, fileName) => {
    navigator.msSaveBlob(new Blob([csv], {type: 'text/csv;charset=utf-8;'}), fileName);
}

const downloadCsv = (csv, fileName) => {
    const encodedUri = 'data:text/csv;charset=utf-8,' + escape(csv);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}